export class ModuleDataHandler {
  moduleData: any;
  numberOfDay: any;

  constructor(moduleData: any, numberOfDay: any) {
    this.moduleData = moduleData;
    this.numberOfDay = numberOfDay;
  }

  calculateBalance(rowIdx: number) {
    const { blank = 0, cl = 0, total = 0 } = this.getListData(rowIdx);
    this.updateListProperty(rowIdx, 'balance', Number(+blank + +cl + +total));
  }

  calculateForPrevBal(rowIdx: number) {
    const { el = 0, prev_blank = 0 } = this.getListData(rowIdx);
    this.updateListProperty(rowIdx, 'blank', Number(+el + +prev_blank));
  }
  //

  // all totals function
  calculateTotal(key_name: any, update_key_name: any) {
    const total = this.moduleData?.list?.reduce(
      (accumulator: any, currentValue: any) => {
        if (currentValue[key_name]) {
          return (+accumulator || 0) + (+currentValue[key_name] || 0);
        }
        return accumulator;
      },
      0
    );
    this.moduleData[update_key_name] = total;
  }

  caclTotalArray(rowIdx: number, key_name: string, update_key_name: string) {
    const total = this.moduleData?.list[rowIdx]?.[key_name]?.reduce(
      (accumalator: any, currentValue: any) => {
        if (currentValue) {
          return (+accumalator || 0) + (+currentValue || 0);
        }
        return accumalator;
      }
    );
    this.updateListProperty(rowIdx, update_key_name, total);
  }

  handleLeavesCal(rowIdx: number) {}

  private getListData(rowIdx: number) {
    return this.moduleData.list[rowIdx];
  }

  private updateListProperty(rowIdx: number, property: string, value: any) {
    this.moduleData.list[rowIdx][property] = value;
  }
}
